/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_Remove_Toast_Success_TitleInputs */

const es_components_credentials_permissions_remove_toast_success_title = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permiso eliminado`)
};

const en_components_credentials_permissions_remove_toast_success_title = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission removed`)
};

/**
* | output |
* | --- |
* | "Permission removed" |
*
* @param {Components_Credentials_Permissions_Remove_Toast_Success_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_remove_toast_success_title = /** @type {((inputs?: Components_Credentials_Permissions_Remove_Toast_Success_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_Remove_Toast_Success_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_remove_toast_success_title(inputs)
	return en_components_credentials_permissions_remove_toast_success_title(inputs)
});
export { components_credentials_permissions_remove_toast_success_title as "components.credentials.permissions.remove.toast.success.title" }